import {getUrlParameterByName} from './url'

export const isCampaignSourceFrom = (campaignSource) => {
    const source = getUrlParameterByName('source')
    if (!campaignSource || !source) return false
    return source.toLowerCase() === campaignSource.toLowerCase()
}
